import random from 'toxilibs/random.js'
import nGramsCommons from './commons/ngrams.js'
import Level from '../core/level.js'

const level = new Level({
    name: 'ngrams_count_23',
    dependencies: [
        'levels/ngrams_count_1',
        'levels/ngrams_cissors_3'
    ]
})

const {
    createQuestion,
    cutCountAndMysteryCountedGram,
    cutCountAndMysteryCount,
    realWords,
    easyRealWords
} = nGramsCommons



level.addQuestion({
    generator: function (q) {
        let word = realWords()
        createQuestion(q, cutCountAndMysteryCount, {word, n: 2, pos: random.intBetween(0, 1)})
    }
})



level.addQuestion({
    generator: function (q) {
        let word = easyRealWords()
        createQuestion(q, cutCountAndMysteryCountedGram, {word, n: 3})
    }
})






export default level

